var _defs, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBurgundyDiagonal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 200",
    preserveAspectRatio: "xMidYMid slice",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bgBurgundy",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#3a0e1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#73223f"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "diagBurgundy",
    width: 20,
    height: 20,
    patternUnits: "userSpaceOnUse",
    patternTransform: "rotate(45)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 20,
    stroke: "#ffffff",
    strokeOpacity: 0.08,
    strokeWidth: 2
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 320,
    height: 200,
    fill: "url(#bgBurgundy)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 320,
    height: 200,
    fill: "url(#diagBurgundy)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurgundyDiagonal);
export default __webpack_public_path__ + "static/media/burgundy-diagonal.6c65d1377f0543c2c3da51db2c9a06e2.svg";
export { ForwardRef as ReactComponent };